import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinIssueEditRoute: InvariantJiraRoute = {
	name: 'legacy-gin-issue-edit',
	path: '/secure/EditIssue([!%]?[\\w]*).jspaa',
};
